import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71636ec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pro-user-container mx-auto max-w-7xl px-6 lg:px-8 py-12" }
const _hoisted_2 = { class: "pro-user-content mx-auto max-w-lg sm:max-w-xl md:max-w-2xl sm:text-center flex flex-col space-y-6 bg-white shadow-lg rounded-lg p-4 sm:p-6 md:p-8" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-500 to-red-500" }, " You are a Pro User! ", -1))
const _hoisted_4 = { class: "text-lg font-medium text-gray-700" }

import { ref } from "vue";
import { FireIcon } from '@heroicons/vue/24/solid';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProUserComponent',
  props: {
  expiryDate: {
    type: String,
    required: true,
  }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(FireIcon), { class: "w-20 h-20 text-red-500 mx-auto" }),
      _createElementVNode("p", _hoisted_4, " Subscription : " + _toDisplayString(__props.expiryDate), 1)
    ])
  ]))
}
}

})